









































import { Component, Vue } from 'vue-property-decorator';
import { sessionModule } from '@/trials/store/modules/session';
import { SysConst as SC } from '@/trials/plugins/const';
import TrainColumn from '@/trials/domain/objects/trainColumn';

@Component
export default class TrainDataStatisticsNa extends Vue {
    /*----------------------------------*
     * Data
     *-----------------------------------*/
    private trainDataStatistics: TrainColumn[] = [];
    /*----------------------------------*
     * ライフサイクルフック
     *-----------------------------------*/
    created() {
        // label以外のデータにする
        const columns: TrainColumn[] = sessionModule.getTrainDataStatistics;
        this.trainDataStatistics = columns.filter((column: TrainColumn) => {
            return !column.isLabel;
        });
    }

    /*----------------------------------*
     * Computed
     *-----------------------------------*/
}
